"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullClipSpaceRange2d = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 */
exports.fullClipSpaceRange2d = rc_js_util_1.Range2d.f32.factory.createOne(-1, 1, -1, 1);
//# sourceMappingURL=full-clip-space-range2d.js.map